export enum CatalogVersionStates {
    Actual,
    Outdated,
    Planned
}